<template>
  <div class="quiz">
    <h1>
      Quiz
      <em>Géographie française</em>
    </h1>
    <p>
      Nous voulions le supprimer, c'est le jeu le plus ennuyeux du journal, mais Michel nous a
      menacé une fois encore si nous l'enlevions, alors pour Michel, voici notre quizz !
    </p>
    <p>
      Aujourd'hui nous allons explorer les régions françaises où personne ne va jamais (mis à part
      Michel). Retrouverez-vous les villes et départements cachés derrière les indications suivantes
      ? Bonne chance !
    </p>
    <h3>Première énigme</h3>
    <p>
      Nous cherchons une ville. A mi-chemin entre Alençon et Argentan, elle est connue pour sa
      cathédrale. Sur le parvis de cette dernière a été réalisée l'oeuvre L'ange de la Cathédrale
      par Yannick Robert.
    </p>
    <h3>Deuxième énigme</h3>
    <p>
      Nous cherchons une ville. Celle-ci plaira aux indécis ! Son château est connu pour abriter le
      musée Louis-Philippe.
    </p>
    <h3>Troisième énigme</h3>
    <p>
      Nous cherchons un département. Il ne faut pas être pressé pour visiter sa préfecture ! Les
      amateurs d'eau-de-vie s'arrêtront dans ce département pour sa fameuse "Folie Douce".
    </p>
    <h3>Quatrième énigme</h3>
    <p>
      Nous cherchons le nom d'un bois. Spéciale dédicasse à Michel qui passe ses vacances chaque été
      au Gite de la Croix du Hêtre.
    </p>
    <br />
    <p>Allez Michel, à la semaine prochaine !</p>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../../shared/Hint";

export default {
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "quiz")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
p,
a {
  color: rgb(35, 35, 35);
  font-family: "Playfair Display", serif;
  font-size: 16px;
}
em {
  font-size: 40%;
  color: #ebc134;
}
.quiz {
  font-family: "Playfair Display", serif;
}
.hints {
  position: absolute;
  bottom: -3%;
  width: 82%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
